import { ReactNode } from 'react';

import { Loader } from 'components/common';

import { Hubs, useAllHubs } from 'hooks/signalR/use-all-hubs.tsx';

type HubsConnectionGuardProps = {
  requiredConnections?: Array<keyof Hubs>;
  renderFallback: () => ReactNode;
  children: ReactNode;
};

const checkConnections = (hubsToCheck: Array<keyof Hubs>, hookValues: Hubs) =>
  hubsToCheck.every((hubName) => hookValues[hubName].isConnected);

/**
 * Component that manages SignalR connections and renders conditionally.
 *
 * It ensures that specified (or otherwise: all) SignalR connections
 * are established before rendering children.
 * Todo: not used by the page wrapper (signal-r-ensure-connection-wrapper)
 */
function HubsConnectionGuard({
  requiredConnections,
  children,
  renderFallback,
}: HubsConnectionGuardProps) {
  const hubHooks = useAllHubs();

  const isConnected = requiredConnections
    ? checkConnections(requiredConnections, hubHooks)
    : checkConnections(Object.keys(hubHooks) as Array<keyof Hubs>, hubHooks);

  if (!isConnected) {
    if (renderFallback) return renderFallback();
    // todo - nobody is currently using this
    return (
      <div className="relative" data-testid="hubs-connection-guard-loading-spinner">
        <Loader linear withBackdrop={false} />
      </div>
    );
  }

  return children;
}

export default HubsConnectionGuard;
